<template>
  <v-app>
    <div class="bckdiv">
      <v-container>
          <v-layout align-center justify-center style="margin-top:200px">
              <v-flex xs12 md8>
                <h1 class="white--text p-5" style="text-align:center;margin-top: -70px;">Gallery</h1>

              </v-flex>

             
                         </v-layout>
                         
              </v-container>
    </div>
    
    <v-container max>
      <v-layout row wrap style="margin-top:50px;">
        
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/1.jpeg" alt="">
              </v-flex>
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/2.jpeg" alt="">
              </v-flex>
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/3.jpeg" alt="">
              </v-flex>
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/4.jpeg" alt="">
              </v-flex>

              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/5.jpeg" alt="">
              </v-flex>
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/6.jpeg" alt="">
              </v-flex>
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/7.jpeg" alt="">
              </v-flex>
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/8.jpeg" alt="">
              </v-flex>

              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/9.jpeg" alt="">
              </v-flex>
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/10.jpeg" alt="">
              </v-flex>
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/11.jpeg" alt="">
              </v-flex>
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/12.jpeg" alt="">
              </v-flex>

              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/13.jpeg" alt="">
              </v-flex>
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/14.jpeg" alt="">
              </v-flex>
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/15.jpeg" alt="">
              </v-flex>
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/16.jpeg" alt="">
              </v-flex>
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/19.jpeg" alt="">
              </v-flex>
              <v-flex class="mb-3" xs12 md4 lg4>
                  <img class="gallery-img" src="../../assets/gallery/20.jpeg" alt="">
              </v-flex>
             
       </v-layout>


    </v-container>



    </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
    };
  },
  
};
</script>

<style scoped>
@import '../../HomeCss/home.css';

@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Bree+Serif|Squada+One&display=swap');
</style>

<style scoped>
  v-app {
    font-family: 'Jost', sans-serif!important;

  }
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.gallery-img {
  max-width: 100%;
  width: 100%;
  height: 240px;
  padding: 10px;
  border-radius: 10px!important;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 50px;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.why-us-img img{
 max-width: 100%;
 max-height: 100%;
 margin-bottom: 25px;
}
.about-us-img {
  max-width: 100%;
  border-radius: 5px;
}
.about-us {
  padding: 15px;
}
.about-us .heading-2 {
 
  color: #697488;

}
.why-us-box {
  padding:20px 50px;
}
.why-us p,.why-us-box p {
  color: #697488;
}
.box {
text-align: center;
}
.box h1 {
  color: #051036;
  font-weight: bold;
}
.box p {
  color: #697488;
}
.team-card {
  color:#051036;
}
.team-card img {
  height: 200px;
  width: 200px;
  border-radius: 5px;
  margin-bottom: 15px;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.enquiry {
    font-family: 'Bree Serif', serif;
}
.contact_tag {
    font-family: 'Space Mono', monospace;
}
.bckdiv {
    background-image: url("../../assets/aboutus.jpg");
    height: 400px;
    background-size: cover;
}
@media screen and (max-width: 763px) {
  .rspnsv {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    background-position: center;
    background-size: cover;
  }
  .team-card {
    text-align: center;
  }
  .help {
    padding-right: 0px !important;
  }
  .aboutTop {
      margin-top: 180px;
      margin-bottom: 100px;
  }
}
@media screen and (min-width: 768px){
  .xyz {
      height: 625px;
  }
}
</style>
